import { TextButton, theme } from '@superhi/design'
import styled from 'styled-components'

export const Wrapper = styled.div`
  &:not(:first-child) {
    margin-top: 40px;
  }

  &:not(:last-child) {
    margin-bottom: 40px;
  }

  border-radius: 10px;
  border: 1px solid ${theme.colors.GREY_50};
`

export const Header = styled(TextButton)`
  display: flex;
  justify-content: space-between;
  padding: 16px;
  width: 100%;
`

export const Content = styled.div`
  padding: 0 16px 16px 16px;
`
